'use client';

import Image from 'next/image';
import styles from './index.module.less';

type SectionWhenCard = {
  imgPath?: string;
  title?: string;
  desc?: string;
};

export default function SectionWhen({ data }: { data: { title?: string; cards?: SectionWhenCard[] } }) {
  const cards = data?.cards ?? [];
  const cardLayoutClasses = [
    [styles.cardLarge, styles.cardBlue],
    [styles.cardWide, styles.cardPurple],
    [styles.cardSmall, styles.cardOrange],
    [styles.cardSmallAlt, styles.cardGreen],
  ];

  return (
    <>
      {data.title && (
        <section className={styles.sectionWhen}>
          <div className={styles.grid}>
            <div className={styles.content}>
              <h2 className={styles.title}>{data.title}</h2>
            </div>
            <div className={styles.cards}>
              {cards.map((card, index) => {
                const layoutClasses = cardLayoutClasses[index] ?? [];
                return (
                  <div key={`${card.title ?? 'card'}-${index}`} className={[styles.card, ...layoutClasses].join(' ')}>
                    <div className={styles.cardInner}>
                      <div className={styles.cardIcon}>
                        <div className={styles.cardIconBox}>
                          {card.imgPath && <Image src={card.imgPath} alt={card.title ?? ''} width={22} height={22} />}
                        </div>
                      </div>
                      <h3 className={styles.cardTitle}>{card.title}</h3>
                      <p className={styles.cardDesc}>{card.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
